// #region Imports
import { defineComponent, nextTick } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-payment-page',
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        pages: {
            type: Array,
            required: false,
            default: []
        },
        process: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        page: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        schemaData: {
            type: Object,
            required: false,
            default: {}
        },
        master: {
            type: Object,
            required: false,
            default: {}
        },
    },
    data: () => ({
        cart: {},
        cartSchema: {},
        cartData: {},
        cartMessages: [],
        cartMode: "express",
        errorMessage: "",
        hasConditionError: false,
        isLoading: false,
        isLoaded: false,
        isWorking: false
    }),
    computed: {
        processID() {
            return this.process?.processID;
        },
    },
    // #endregion
    // #region Constructor
    async beforeMount() {
        await this.loadData();
    },
    // #endregion
    // #region Core
    methods: {
        // #region Boostrap
        async loadData() {
            // #region Check
            if (utils.isNullOrEmpty(this.processID)) {
                return;
            }
            // #endregion
            // #region Reset
            if (this.cartData?.conditionsconfirmed) {
                this.cartData.conditionsconfirmed = false;
            }
            // #endregion
            // #region Run
            //Loading
            this.isLoading = true;
            host.api.get(`forms/checkout/${this.processID}?mode=${this.cartMode}`)
                .then(e => {
                if (e.data?.$dataMode) {
                    this.cartMode = e.data?.$dataMode;
                }
                if (e.data?.cart) {
                    this.cart = e.data.cart;
                }
                if (e.data?.data) {
                    this.cartData = e.data.data;
                }
                if (e.data?.schema) {
                    this.cartSchema = e.data.schema;
                }
                if (e.data?.messages) {
                    this.cartMessages = e.data.messages;
                }
                nextTick(() => {
                    this.isLoading = false;
                    this.isLoaded = true;
                });
            })
                .catch(e => {
                host.notification.showToast(utils.getAxiosErrorMessage(e), "error");
                this.isLoading = false;
            });
            // #endregion
        },
        // #endregion
        // #region Core
        async commit() {
            // #region Validate
            let tForm = this.$refs?.frmMain?.$form;
            {
                if (tForm && !tForm.validate()) {
                    return;
                }
            }
            if (this.cartSchema?.options?.agb_Caption && !this.cartData.conditionsconfirmed) {
                this.hasConditionError = true;
                return;
            }
            // #endregion
            // #region Meter
            this.isWorking = true;
            // #endregion
            // #region Events
            let tArgs = {
                cancel: false,
                mode: this.cartMode,
                cart: this.cart,
                data: this.cartData
            };
            //Run
            await host.eventBus.emit('checkout-before-commit', tArgs);
            //Check
            if (tArgs.cancel) {
                this.isWorking = false;
                return;
            }
            // #endregion
            // #region Save
            this.saveData('next', async (nextMode) => {
                // #region Speical
                if (nextMode === 'activate') {
                    await host.login.loginByUsername(this.data.profile.eMail, this.data.profile.password);
                }
                // #endregion
                // #region Meter
                this.isWorking = false;
                // #endregion
                // #region Rounting
                this.$emit('command', 'reload-and-next');
                // #endregion
            });
            // #endregion
        },
        async saveData(operationName, onSaved = undefined) {
            // #region Meter
            this.isLoading = true;
            // #endregion
            // #region Save
            try {
                // #region Path
                let e = await host.api.patch(`forms/checkout/${this.cart.cartID}?mode=${this.cartMode}&operation=${operationName}`, this.cartData);
                // #endregion
                // #region Payment
                if (e.data?.$nextMode === 'payment-confirm') {
                    //Run
                    this.runPayment(e.data.payment);
                    //Finish
                    this.isLoading = false;
                    this.isWorking = false;
                    return;
                }
                // #endregion
                // #region Internal
                if (e.data?.cart) {
                    this.cart = e.data.cart;
                }
                if (e.data?.data) {
                    this.cartData = e.data.data;
                }
                if (e.data?.schema) {
                    this.cartSchema = e.data.schema;
                }
                if (e.data?.messages) {
                    this.cartMessages = e.data.messages;
                }
                //if (e.data?.user) {
                //    this.user = e.data.user;
                //}
                // #endregion
                // #region Next
                if (onSaved) {
                    onSaved(e.data?.$nextMode);
                }
                // #endregion
                // #region Loading
                this.isLoading = false;
                // #endregion
            }
            // #endregion
            // #region Error
            catch (error) {
                // #region Data
                if (error.response?.data?.messages) {
                    this.cartMessages = error.response?.data?.messages;
                }
                else {
                    host.notification.showToast(utils.getAxiosErrorMessage(error), "error");
                }
                // #endregion
                // #region Loading
                this.isLoading = false;
                this.isWorking = false;
                // #endregion
            }
            // #endregion
        },
        async runPayment(data) {
            // #region Simple (URL)
            if (data?.nextAction === 'redirect_to_url') {
                window.location.href = data.nextActionUrl;
            }
            // #endregion
            // #region Run
            else {
                // #region Gateway
                //Gateway
                let tGateway = this.$host.provider.get('PAYMENT', data.gateway.clientType);
                //Init
                await tGateway.initialize(data.gateway);
                //Handle
                let tResult = await tGateway.handle(data.nextAction, data);
                // #endregion
                // #region Result
                if (!tResult.isSucceeded) {
                    this.cartMessages.push({
                        style: 'danger',
                        description: tResult.errorMessage,
                    });
                }
                else if (tResult.nextAction === 'confirm') {
                    this.saveData('payment-confirm', async (nextMode) => {
                        // #region Meter
                        this.isWorking = false;
                        // #endregion
                        // #region Rounting
                        this.$router.push({ params: { mode: nextMode ?? 'cart' } });
                        // #endregion
                    });
                }
                // #endregion
            }
            // #endregion
        },
        // #endregion
        // #region Command
        onCommand(command, args) {
            this.$emit('command', command, args);
        },
        cmdRemoveMessage(message) {
            // #region Api
            host.api.delete(`forms/checkout/${this.cart.cartID}/messages/${message.id}`);
            // #endregion
            // #region Remove
            this.cartMessages.splice(this.cartMessages.indexOf(message));
            // #endregion
        },
        // #endregion
    },
    // #endregion
});
// #endregion
